/*@flow*/
import CustomError from 'lib/CustomError';

type ResponseT = Response;

function throwCustomError(response: ResponseT) {
  const { status, statusText } = response;

  let msg = 'Error from the server.';

  if (status === 0) {
    msg =
      "Opaque response detected. You can't use this mode for cross origin requests.";
  } else {
    msg = statusText;
  }

  const error: CustomError<ResponseT> = new CustomError(msg);
  error.response = response;
  throw error;
}

export default function checkStatus(response: ResponseT): void | ResponseT {
  if (response.status >= 200 && response.status < 400) {
    return response;
  }
  throwCustomError(response);
}
